import apiClient from '../api-client/apiClient'
import apiClient3 from '../api-client/apiClient3';
// const API_BASE_URL = 'https://api-uat.iciciprulife.com/v1/biu-instatrack'; 

/**
 * Authenticates a user and logs them in.
 * @param {string} ntID - The user's NTID.
 * @param {string} password - The user's password.
 * @param {string} appNumber - The application number.
 * @returns {Promise<object>} - A promise that resolves with the login response data.
 */
export const loginUser = async (ntID, password, appNumber) => {
  try {
    const response = await apiClient3.post(process.env.REACT_APP_LDAP_URL, {
      ntID,
      password,
      app_number: appNumber,
    });
    // If login is successful, you might want to store the session_id or a token
    const session_id = crypto.randomUUID()
    localStorage.setItem('sessionId', session_id);
    localStorage.setItem('userNtid', ntID);
    localStorage.setItem('appNumber', appNumber)
    // return response.data;
    return {
      "ntID": ntID,
      "session_id": session_id,
      "appNumber": appNumber
    }
  } catch (error) {
    console.error('Login API call failed:', error);
    throw error;
  }
};

/**
 * Logs out a user and terminates their session.
 * @param {string} ntid - The user's NTID.
 * @param {string} sessionId - The active session ID.
 * @returns {Promise<object>} - A promise that resolves with the logout response data.
 */
export const logoutUser = async (ntid, sessionId) => {
  try {
    const response = await apiClient.post('/logout', {
      ntid,
      session_id: sessionId,
    });
    localStorage.removeItem('sessionId');
    localStorage.removeItem('userNtid');
    return response.data; // Returns { message: "Logout successful" }
  } catch (error) {
    console.error('Logout API call failed:', error);
    throw error;
  }
};

/**
 * Starts a new chat session.
 * @param {string} sessionId - The session ID.
 * @param {string} userId - The user's ID (e.g., NTID).
 * @param {string} appNumber - The application number.
 * @returns {Promise<object>} - A promise that resolves with the start chat response data.
 */
export const startChat = async (sessionId, userId, appNumber) => {
  try {
    const response = await apiClient.post('/start', {
      session_id: sessionId,
      user_id: userId,
      app_number: appNumber,
    });
    return response.data; 
  } catch (error) {
    console.error('Start chat API call failed:', error);
    throw error;
  }
};

/**
 * Sends a message to the chat assistant.
 * @param {string} userId - The user's ID (e.g., NTID).
 * @param {string} sessionId - The session ID.
 * @param {string} appNumber - The application number.
 * @param {string} message - The user's message.
 * @returns {Promise<object>} - A promise that resolves with the chat response data.
 */
export const sendMessage = async (userId, sessionId, appNumber, message) => {
  try {
    const response = await apiClient.post('/send', {
      user_id: userId,
      session_id: sessionId,
      app_number: appNumber,
      message,
    });
    return response.data; // Returns { response: "..." }
  } catch (error) {
    console.error('Send message API call failed:', error);
    throw error;
  }
};

/**
 * Retrieves the chat history for a given session.
 * @param {string} userId - The user's ID (e.g., NTID).
 * @param {string} sessionId - The session ID.
 * @returns {Promise<object>} - A promise that resolves with the chat history data.
 */
export const getChatHistory = async (userId, sessionId) => {
  try {
    const response = await apiClient.post('/history', {
      user_id: userId,
      session_id: sessionId,
    });
    // The response should be { messages: [{ sender: "user", content: "..." }, ...] }
    return response.data;
  } catch (error) {
    console.error('Get chat history API call failed:', error);
    throw error;
  }
};

/**
 * Submits feedback to the system.
 * @param {string} feedbackType - The type of feedback ('helpful' or 'not_helpful').
 * @param {string} query - The user's query.
 * @param {string} response - The chat assistant's response.
 * @returns {Promise<object>} - A promise that resolves with the feedback submission response data.
 */
export const submitFeedback = async (feedbackType, query, response) => {
  try {
    const res = await apiClient.post('/feedback', {
      feedback_type: feedbackType,
      query,
      response,
    });
    return res.data; // Returns { message: "Feedback recorded successfully." }
  } catch (error) {
    console.error('Submit feedback API call failed:', error);
    throw error;
  }
};

// export const updateSsoUserId = async (ssokey) => {
//   try {
//     const response = await apiClient.post('/update-user-id', {
//       key:ssokey
//     });
//     return response.data; 
//   } catch (error) {
//     console.error('Start chat API call failed:', error);
//     throw error;
//   }
// };
